import { useGetAdvertiserSettingsInfoQuery, useUpdateAdvertiserUserSettingsMutation } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useUpdateDocumentTitle, useQueryHelper } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { SettingsForm, SettingsFormValues, getSettingsFormValues } from '@anytag/shared-organisms';
import { FormAction } from '@anytag/shared-types';

export const Settings = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Settings', appHeader: 'appHeader.Settings' });
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { callUpdateAdvertiserUserSettings } = useUpdateAdvertiserUserSettingsMutation();
  const { data, loading } = useGetAdvertiserSettingsInfoQuery({
    onError: (error) => {
      enqueueSnackbar(t(error?.message || 'cannot get account settings information'), { variant: 'error' });
      navigate({ to: '/' });
    }
  });

  const handleSubmit: FormAction<SettingsFormValues>['onSubmit'] = async ({
    name,
    email,
    countryId,
    advertiserName,
    advertiserCountryId,
    notificationSetting,
    advertiserCompanyUrl,
    advertiserPhoneNumber
  }) => {
    try {
      await callUpdateAdvertiserUserSettings({
        variables: {
          input: {
            name,
            email,
            countryId,
            advertiserName,
            advertiserCountryId,
            notificationSetting,
            advertiserCompanyUrl,
            advertiserPhoneNumber
          }
        }
      });

      enqueueSnackbar(t('Account Settings were successfully saved'), { variant: 'success' });
      navigate({ to: '/' });
    } catch (error) {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  };

  return (
    <RenderDataWithFallback loading={loading}>
      <div>
        <Header />

        <SettingsForm
          onSubmit={handleSubmit}
          defaultValues={getSettingsFormValues(data?.advertiserUserSettingsDetails)}
        />
      </div>
    </RenderDataWithFallback>
  );
};
